/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-11 14:05:30
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextStyle, Banner } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  tenantApp: Object
};

type ComposedProps = Props & WithI18nProps;

class ThemeUpgradeFlow1Notification extends Component<ComposedProps> {
  handleAction = () => {
    history.push(routes.landingPage.view());
  };
  render() {
    const { tenantApp, i18n } = this.props;
    const { adminAppFeatures = {}, upgradeThemeV2 } = tenantApp;
    const { themeSetupV2 = false } = adminAppFeatures;
    const sendMailAt = upgradeThemeV2 ? upgradeThemeV2.sendMailAt : 0;
    const enableBanner = !themeSetupV2 && sendMailAt > 0;

    if (!enableBanner) return null;

    return (
      <Banner
        title={i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow1Notification.title')}
        status="warning"
        action={{
          content: i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow1Notification.actionLabel'),
          onAction: this.handleAction
        }}>
        <p>
          {i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow1Notification.content', {
            t1: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow1Notification.content_t1')}
              </TextStyle>
            ),
            t2: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow1Notification.content_t2')}
              </TextStyle>
            ),
            t3: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow1Notification.content_t3')}
              </TextStyle>
            ),
            t4: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.ThemeSetup.ThemeUpgradeFlow1Notification.content_t4')}
              </TextStyle>
            )
          })}
        </p>
      </Banner>
    );
  }
}

const mapStateToProps = state => ({
  tenantApp: _.get(state.oauth, 'tenantApp', {})
});

export default connect(mapStateToProps)(withI18n()(ThemeUpgradeFlow1Notification));
